/**
 * The two glyphs the Strip Card board draws: the lock an undrawn row shows
 * and the sliders on a strip's Manage button. Decorative only; the control
 * around each one carries the name.
 */
import { cn } from "@sportsmet/ui";
import type { ReactNode } from "react";

export function StripLockGlyph(props: { className?: string }): ReactNode {
  return (
    <svg
      className={cn("h-icon-sm w-icon-sm shrink-0", props.className)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-icon="lock"
    >
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  );
}

export function StripSlidersGlyph(props: { className?: string }): ReactNode {
  return (
    <svg
      className={cn("h-icon-sm w-icon-sm shrink-0", props.className)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
      data-icon="sliders"
    >
      <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0" />
      <circle cx="16" cy="6" r="2" />
      <circle cx="10" cy="12" r="2" />
      <circle cx="18" cy="18" r="2" />
    </svg>
  );
}
